export const newsContent = [
  {
    id: 2,
    title: "Nueva Beca de Útiles Escolares 2026",
    date: "2025-08-13",
    content: "Ya está disponible la Beca de Útiles Escolares 2026 para nuestros apoderados. Puedes encontrar el documento en la sección Informaciones del sitio, con el nombre ‘Beca útiles escolares 2026’.",
    content2: "",
    image: "",
    isNew: true
  },
  {
    id: 1,
    title: "Inicio del Año Escolar 2025",
    date: "2025-02-26",
    content:  ``,
    content2: "",
    image: "",
    isNew: true
  },
];

export default newsContent;

